import ThumbsDownIconSVG from "../../../SharedComponents/assets/icons/svg/ThumbsDownIconSVG";
import ThumbsUpIconSVG from "../../../SharedComponents/assets/icons/svg/ThumbsUpIconSVG";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";

const PartOfferSellerRatingVisualsator = ({
    positiveCount,
    negativeCount
}) => {
    return (
        <div style={styles.mainContainer}>
            <p style={styles.sellerText}>
                Prodavac
            </p>

            <div style={styles.ratingContainer}>
                <ThumbsUpIconSVG />

                <p style={styles.countText}>
                    {positiveCount}
                </p>
            </div>


            <div style={styles.ratingContainer}>
                <ThumbsDownIconSVG />

                <p style={styles.countText}>
                    {negativeCount}
                </p>
            </div>
        </div>
    );
};

export default PartOfferSellerRatingVisualsator;


const styles = {
    mainContainer: {
        display: 'flex',
        width: 'max-content',
        gap: 10,
        alignItems: 'center',
        justifyContent: 'center'
    },
    sellerText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    ratingContainer: {
        display: 'flex',
        width: 'max-content',
        gap: 6,
        alignItems: 'center',
        justifyContent: 'center'
    },
    countText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)"
    }
}